<!-- eslint-disable vue/no-unused-vars -->
<template>
    <v-container>
        <v-row class="linha-quantidades">
            <v-col cols="12" md="1">
                <h1>Cards</h1>
            </v-col>

            <v-col cols="12" md="11">
                <v-row class="d-flex justify-end">
                    <v-col class="d-flex justify-end" v-for="(item, index) in quantityItems" :key="index" cols="12"
                        md="2">
                        <div class="box-tipo-quantidade text-center">
                            <label>{{ item.label }}</label>
                            <div :class="['box-quantidade', item.borderClass]">{{ item.count }}</div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row class="linha-cards">
            <v-col class="v-col" v-for="(equip, index) in equipamentosFiltrados" :key="equip.idEquipamento" cols="12"
                lg="2" md="4" sm="4" xs="6">
                <CardEquipamento :registro="equip" @click-action="onCardClick(equip.idEquipamento)" />
            </v-col>
        </v-row>

        <v-row v-if="loading">
            <v-col cols="12">
                <p>Carregando dados...</p>
            </v-col>
        </v-row>

        <v-row v-if="error">
            <v-col cols="12">
                <p class="error-message">Erro ao carregar dados: {{ error }}</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CardEquipamento from './CardEquipamento.vue';
    import axios from 'axios';
    import { eventBus } from './core/EventBus';

    export default {
        components: { CardEquipamento },
        data() {
            return {
                quantityItems: [],
                equipamentosFiltrados: [],
                equipamentos: [],
                loading: true,
                error: null
            };
        },
        async mounted() {
            await this.fetchData();
            eventBus.on("filtrar-equipamentos", this.filtrarEquipamentos);
        },
        beforeUnmount() {
            eventBus.off("filtrar-equipamentos", this.filtrarEquipamentos);
        },
        methods: {
            async fetchData() {
                try {
                    const response = await axios.get('https://infinity-refrisat.com/equipamentos');
                    const data = response.data;

                    this.quantityItems = [
                        { label: "Pronto Para Partir", count: data.quantidades.prontos, borderClass: "borda-cinza" },
                        { label: "Em Operação", count: data.quantidades.emOperacao, borderClass: "borda-verde" },
                        { label: "Operação Com Alarme", count: data.quantidades.operacaoAlarme, borderClass: "borda-amarela" },
                        { label: "Parado", count: data.quantidades.parados, borderClass: "borda-vermelha" }
                    ];

                    this.equipamentos = this.ordenar(data.equipamentos);
                    this.equipamentosFiltrados = this.equipamentos;

                } catch (err) {
                    this.error = "Falha ao carregar os dados.";
                    console.error("Erro na requisição:", err);
                } finally {
                    this.loading = false;
                }
            },
            filtrarEquipamentos(filtro) {
                if (!filtro) {
                    this.equipamentosFiltrados = this.equipamentos;
                    return;
                }
                filtro = filtro.toLowerCase();
                this.equipamentosFiltrados = this.equipamentos.filter(eq =>
                    eq.equipamento.nome.toLowerCase().includes(filtro) || eq.empresa.toLowerCase().includes(filtro)
                );
                this.equipamentosFiltrados = this.ordenar(this.equipamentosFiltrados);
            },
            onCardClick(id) {
                this.$router.push(`/equipamento/${id}`);
            },
            ordenar(registros) {
                return registros.sort((a, b) => {
                    if (b.equipamento.qtdTrip !== a.equipamento.qtdTrip) {
                        return b.equipamento.qtdTrip - a.equipamento.qtdTrip;
                    }
                    return b.equipamento.qtdAlarme - a.equipamento.qtdAlarme;
                });
            }
        }
    };
</script>

<style scoped>
.linha-quantidades {
    justify-content: flex-end;
}

.box-tipo-quantidade {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
}

.box-quantidade {
    min-width: 53px;
    min-height: 35px;
    max-width: 53px;
    max-height: 35px;
    background-color: var(--cor-secundaria);
    border-radius: 5px;
    border: 2px solid;
    display: flex;
    justify-content: center;
    align-items: center;
}

.borda-cinza {
    border-color: #6C6C6C;
}

.borda-verde {
    border-color: #0CA42E;
}

.borda-amarela {
    border-color: #8D750D;
}

.borda-vermelha {
    border-color: #A31010;
}

.error-message {
    color: #ff0000;
    font-weight: bold;
}

@media screen and (max-width: 640px) {
    .linha-quantidades {
        width: 100%;
    }

    .linha-cards {
        margin-top: 30px !important;
    }

    .v-col {
        display: flex;
        justify-content: center;
    }
}
</style>
